import type { AnimatedCursorImage } from "../extension/client.types"

type CursorAnimation = Pick<AnimatedCursorImage, "frames" | "animationSpeed" | "animationDirection">

/*
 * How the extension plays an animated cursor: its frames in play order and how long each shows.
 * Its CSS animation spends animationSpeed on one pass over the frames, and alternate turns on each
 * end frame without repeating it, spending one animationSpeed on each direction.
 * */
export const cursorPlayback = ({ frames, animationSpeed, animationDirection }: CursorAnimation) => {
  if (animationDirection !== "alternate") {
    return { frames, frameMs: animationSpeed / frames.length }
  }

  const sequence = frames.concat(frames.slice(1, -1).reverse())
  return { frames: sequence, frameMs: (animationSpeed * 2) / sequence.length }
}
